<template>
  <div class="scrolling-ticker d-flex" :class="{'scrolling-active': scrolling}">
    <div v-if="confettiMessage" class="confetti-ticker gg-branding-supporting">{{ confettiMessage }}</div>
    <div v-else class="ticker d-flex" ref="ticker">
      <TickerStat v-if="statsInclude('num_receiving_orgs')" :label="orgLabel" :stat="dogStat('num_receiving_orgs')" imageName="ribbon"></TickerStat>
      <TickerStat v-if="statsInclude('total_donors_count')" label="Donors" :stat="dogStat('total_donors_count')" imageName="group"></TickerStat>
      <TickerStat v-if="statsInclude('total_donations_count')" label="Gifts" :stat="dogStat('total_donations_count')" imageName="hearthands"></TickerStat>
      <div v-if="textToGiveNumber" class="text-to-give mx-2 gg-branding-supporting">
        <img :src="chatImageUrl" alt="">
        <span>Text "GIVE" to {{ textToGiveNumber }}</span>
      </div>
    </div>

    <div v-if="scrolling && !confettiMessage" class="ticker d-flex ticker-duplicate">
      <TickerStat v-if="statsInclude('num_receiving_orgs')" :label="orgLabel" :stat="dogStat('num_receiving_orgs')" imageName="ribbon"></TickerStat>
      <TickerStat v-if="statsInclude('total_donors_count')" label="Donors" :stat="dogStat('total_donors_count')" imageName="group"></TickerStat>
      <TickerStat v-if="statsInclude('total_donations_count')" label="Gifts" :stat="dogStat('total_donations_count')" imageName="hearthands"></TickerStat>
      <div v-if="textToGiveNumber" class="text-to-give mx-2 gg-branding-supporting">
        <img :src="chatImageUrl" alt="">
        <span>Text "GIVE" to {{ textToGiveNumber }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TickerStat from './TickerStat.vue'
import debounce from 'lodash/debounce'

export default {
  name: 'ScrollingTicker',
  components: {
    TickerStat,
  },
  data () {
    return {
      scrolling: false,
    }
  },
  computed: {
    ...mapGetters(['custom', 'dogStat']),
    chatImageUrl () { return `https://s3.amazonaws.com/gg-day-of-giving/${this.$store.state.dog.name}/icons/chatbubble.svg` },
    confettiMessage () { return this.$store.state.confettiMessage },
    orgLabel () {
      let orgLabels = this.$store.state.dog.dog_breed.org_label_set;
      return (this.dogStat('num_receiving_orgs') === 1) ? orgLabels.singular : orgLabels.plural;
    },
    textToGiveNumber () { return this.custom('text_to_give_number') },
  },
  mounted () {
    window.addEventListener('resize', debounce(this.toggleScrolling, 200));
    this.toggleScrolling();
  },
  methods: {
    statsInclude (statName) {
      return this.custom('displayed_stats').overall.includes(statName);
    },
    toggleScrolling () {
      if (!this.confettiMessage) {
        // Don't attempt to check ticker width when the $ref element isn't in the DOM
        this.scrolling = this.$refs.ticker.offsetWidth > window.innerWidth;
      }
    },
  },

  watch: {
    confettiMessage (newMsg) {
      if (!newMsg.length) {
        this.$nextTick(() => this.toggleScrolling())
      }
    }
  },
}
</script>

<style scoped lang="scss">
.scrolling-ticker {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 10vh;
  background-color: #eaeaea;
  font-weight: bold;
  font-size: 1.75rem;
  align-items: center;
}
.ticker {
  min-width: 100vw;
  flex-shrink: 0;
}
.scrolling-active .ticker {
  animation-name: ticker;
  animation-duration: 15s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.text-to-give {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;

  img {
    height: 10vh;
    width: 10vh;
  }
}

.confetti-ticker {
  padding-right: 20vw;
  padding-left: 3rem;
  text-align: left;
  flex-shrink: 0;
  animation-name: confetti;
  animation-duration: 15s;
  animation-iteration-count: 1;
  animation-timing-function: linear;
}

@keyframes ticker {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

@keyframes confetti {
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(calc(-100%));
  }
}
</style>
